'use client';

import { useCartInfoAtom } from '@/state';
import * as Sentry from '@sentry/nextjs';
import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { isCartMerging, mergeCartWithNotification } from '../../utils/mergeCartWithNotification';

// カートのクリーンアップ（バージョンチェック）
// ログイン済みでlocalStorageにカートが残っている場合はサーバーにマージ
// NOTE: useLogin / SignUpConfirmForm もマージを呼ぶため、isCartMerging() で二重発火を防止（GF-1670）
function GfCheckCart({
  isLogin,
}: {
  isLogin: boolean;
}) {
  const [cartInfo, , clearCartInfo] = useCartInfoAtom();
  const router = useRouter();
  const isMergingRef = useRef(false);

  useEffect(() => {
    // カートのバージョンが古い場合はクリア
    const isOldVersion = () => {
      if (!cartInfo || !cartInfo.cartVersion) {
        return true;
      }
      return cartInfo.cartVersion !== Number(process.env.NEXT_PUBLIC_LOCAL_CART_VERSION || 1);
    };

    if (isOldVersion()) {
      clearCartInfo();
      return;
    }
    // 30日経過したアイテムの削除はAPI側（hasExpiredItems）に委譲
  }, [cartInfo, clearCartInfo]);

  useEffect(() => {
    const migrateCart = async () => {
      // 他の導線（useLogin / SignUpConfirmForm）でマージ中の場合はスキップ
      if (isCartMerging()) return;
      // 自身の二重実行を防止
      if (isMergingRef.current) return;
      if (!isLogin || !cartInfo.items || cartInfo.items.length === 0) return;

      isMergingRef.current = true;
      try {
        await mergeCartWithNotification(cartInfo.items, clearCartInfo);
        router.refresh();
      } catch (error) {
        Sentry.captureException(error);
      } finally {
        isMergingRef.current = false;
      }
    };
    migrateCart();
  }, [isLogin, cartInfo, clearCartInfo, router]);

  return <></>;
}

export default GfCheckCart;
